/* 
 * we run last, and check if we are on the cordova framework, if so we invoke the framework callback 
 */

if (otuApp.isCordovaApp()) {

		if (device.platform=='Android' || device.platform=='browser') {
			canAutoPlay=true;
		}

		// we add the background handler 
		if (device.platform!=='browser') {
			document.addEventListener("pause", function() {
				console.log('myApp - App paused');
				otuApp.stopAnimations();			
				
			}, false);
		}

		if (device.platform=='browser') {
			device.uuid='browser1';
		}
		
		// we register the back is menu button
		document.addEventListener('backbutton', function(event){
			  event.preventDefault(); // EDIT
			  console.log('Hardware Back Button - Triggered')
			  otuApp.pageNavigation.restoreTask();
			});
	
		// we extend the myApp with the online version start
		console.log('myApp - Extending myApp with dynamic functions');
		
		myApp.getToken = function () {
			var handShake={
					token:myApp.settings.token,
					device:device,
					version:myApp.version
			};			
			var token=window.btoa(JSON.stringify(handShake));
			return token;	
		};
		myApp.setToken=function (token) {
			myApp.settings.token=token;
			myApp.writeSettings({
				onSuccess:function(){
					console.log('myApp - Token set')
				},
				onError:function(e){
					console.log('myApp - Error setting token');
					console.log(e);
				}				
			})
		};
		myApp.appStateRefresh = function() {
			console.log('myApp - App State Refresh');

			// if we have a new token we save it and remove it
			if (typeof otuApp.appState.appToken!=='undefined') {
				if (myApp.settings.token!=otuApp.appState.appToken) {
					console.log('myApp - Saving new token');
					myApp.setToken(otuApp.appState.appToken);
				}
				delete otuApp.appState.appToken;
			}
			
			// check if we need to unlock the rotation;
			console.log('myApp - Checking rotation');
			if (typeof otuApp.appState.templateParams!=='undefined') {
				if (typeof otuApp.appState.templateParams.lockOrientation!=='undefined') {
					if (otuApp.appState.templateParams.lockOrientation=='unlocked') {
						myApp.unlockScreenOrientation()
					} else {
						myApp.lockScreenOrientation({orientation:otuApp.appState.templateParams.lockOrientation});
					}
				} else {
					myApp.unlockScreenOrientation()
					console.log('myApp- Screen rotation unlocked');
				}
			}
			
		};
		myApp.startOnlineApp = function () {
			console.log('myApp - Starting Online App with url:');

			var url=frameWork.options.KIUrl + 'index.php?component=com_otu_op&view=ops&task=app.getBase&tmpl=app_base';

			console.log(url);
			
			otuApp.triggerAjaxGet(url,{
					attr: {"data-disable-ajax-wrapper":true},
					callback : function () {
						// call StateRefresh
						console.log('myApp - Online App Loaded')
						messaging.initNotifications();
						//otuApp.appStateRefresh();
					}
				});		
		},
		myApp.logOut = function () {
			console.log('myApp - Attempting to log out');
			
			myApp.setToken(null);
	
			var url=frameWork.options.KIUrl + 'index.php?component=com_otu_op&view=ops&task=logout';
			
			console.log(url);
			
			otuApp.triggerAjaxGet(url,{
					attr: {}
				});		
		},
		myApp.restartApp = function (options){
			location.reload(); 
		},
		myApp.quit = function (options) {
			navigator.app.exitApp();
		},
		myApp.background = function (options) {
			navigator.Backbutton.goHome(function() {
				console.log('Hardware Back Button - Backgrounded');
			  }, function() {
				console.log('Hardware Back Button - Failed Backgrounding');
			  });
		},
		myApp.unlockScreenOrientation = function (options) {
			if ( typeof screen.orientation !== 'undefined' 
						&& typeof screen.orientation.unlock === 'function') { 
						// The standard screen.orientation.unlock() method exists
						screen.orientation.unlock();
			} else if (typeof screen.unlockOrientation === 'function') {
						// The non-standard screen.unlockOrientation() method exists
						screen.unlockOrientation();
			} else {
						console.log('Screen orientation unlock method is not supported');
			}
		},
		myApp.lockScreenOrientation = function ( options) {
			var orientation = (options && options.orientation) || 'portrait';

			if ( typeof screen.orientation !== 'undefined' 
				&& typeof screen.orientation.lock === 'function') { 
				// The standard screen.orientation.unlock() method exists
				screen.orientation.lock( orientation );
			} else if (typeof screen.lockOrientation === 'function') {
						// The non-standard screen.unlockOrientation() method exists
						screen.lockOrientation( orientation );
			} else {
						console.log('Screen orientation unlock method is not supported');
			}
		}
} else {
	$( document ).ready(function() {
		otuApp.appStateRefresh();	
	})		
}